import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import { entityPersonasJuridicaAdapter, EntityPersonasJuridicaState } from './entity-personas-juridica.state';

const { selectEntities, selectAll } =
  entityPersonasJuridicaAdapter.getSelectors();

export const getError = (state: EntityPersonasJuridicaState): any =>
  state.error;

export const getIsLoading = (state: EntityPersonasJuridicaState): boolean =>
  state.isLoading;

export const selectPersonasJuridicaState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.personasJuridica
);

export const selectAllPersonasJuridica = createSelector(
  selectPersonasJuridicaState,
  selectAll
);
export const selectEntitiesPersonasJuridica = createSelector(
  selectPersonasJuridicaState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectPersonasJuridicaError = createSelector(
  selectPersonasJuridicaState,
  getError
);

// MemoizedSelector<object,any>
export const selectPersonasJuridicaIsLoading = createSelector(
  selectPersonasJuridicaState,
  getIsLoading
);
